import type { UpdStatus } from '@/api/generated/model';

/** Пока документ в этих статусах, список сам опрашивает сервер (DoD дня 31). */
export const IN_PROGRESS: UpdStatus[] = ['uploaded', 'parsing'];
